import { CardContent, SkeletonLoader, makeArrayFromLength, WrapperCardGrid } from "oolib";
import React from "react";


import { TotalCount } from "../../../TotalCount";
import { ListingSectionTitle } from "../../../ListingSectionTitle";
import { listingWrapperSelector } from "../../utils/listingWrapperSelector";
import DownloadDataButton from "../../DownloadDataButton";
import { getTenant } from "../../../../../../TENANT_CONFIGS";
import { pluginConfigs } from "../../../../../../Plugins/_EXPORTS";
import { parseSpecialConfigSyntax } from "@okf/ootils";
import { useGetQueryData } from "@/utils/react-query-hooks/general";
import { handleShowUnderEditInfoOnCardOrListItem } from "@/_self_managed/utils/handleShowUnderEditInfoOnCardOrListItem";

const FallbackWrapper = ({children, enableContainerQuery}) => <div enableContainerQuery={enableContainerQuery}>{children}</div>


const CardsStyle = ({
  data,
  status,
  isFetchingNextPage,
  observerRef,
  totalCount,
  sectionTitle,
  sectionLink,
  configs: configs_,
  ListingWrapper,
  onClick,
  enableContainerQuery,
  inTCI,
  getDataToBeExported,
  linkTo

}) => {

const {SELF_MANAGED_BASE_CONFIGS} = useGetQueryData('platformConfigs')

  const Wrapper = listingWrapperSelector({
    ListingWrapper,
    FallbackWrapper
  })

  const genSkeletonCards = () =>
    makeArrayFromLength(6).map(() => (
      <SkeletonLoader
        style={{
          height: "20rem",
        }}
      />
    ));
  const genContentCards = (data) =>
    data?.map((content, index) => {
      let d, configs, pluginExtraProps;
      
      if(pluginConfigs[getTenant()]?.ListingModule?.highlightPlugin){
        const {cardData, cardConfig, extraProps} = pluginConfigs[getTenant()]?.ListingModule?.highlightPlugin({cardData: content, cardConfig: configs_});
        d = cardData;
        configs = cardConfig;
        pluginExtraProps = extraProps
      }else{
        d = content;
        configs = configs_;
      }
 
      if(SELF_MANAGED_BASE_CONFIGS?.listingConfig?.showUnderEditInfoOnCardOrListItem === true){
        const {config: editedConfig, content: editedContent, extraProps = {}} = handleShowUnderEditInfoOnCardOrListItem({content: d, config: configs})
        d = editedContent
        configs = editedConfig
        pluginExtraProps = {
          ...(pluginExtraProps || {}),
          ...extraProps
        }
      }
      
      let contentType = d.meta.kp_content_type;
      
      //read in the function what paeseSpecialConfigSyntax does. if there is no special config, it will return the link string as is.
      let cardLinkUrl = onClick //cuz both cant exist at the same time
        ? undefined
        : linkTo && parseSpecialConfigSyntax({config: linkTo, content: d})
      
      return (
       
        <div key={d._id} ref={data.length === index + 1 ? observerRef : null}>
          <CardContent
            id={d._id}
            data={d}
            to={cardLinkUrl}
            onClick = {onClick}
            highlight={d?.highlight}
            config={configs}
            {...(pluginExtraProps || {})}
          />
        </div>
      );
    });
   
  return (

      <Wrapper left enableContainerQuery={enableContainerQuery}>
       <div style={{display:"flex", paddingBottom:"1rem", gap: '8px' }}> 
       
        {totalCount !== undefined && <TotalCount  totalCount={totalCount}  />}
      
              {
                 getDataToBeExported && (
                  <>
                    <DownloadDataButton getDataToBeExported={getDataToBeExported}/>
                    
                  </>
                 )
              }
         </div>       
          
        {(sectionTitle || sectionLink) && (
          <ListingSectionTitle
            sectionTitle={sectionTitle}
            sectionLink={sectionLink}
          />
        )}
        <WrapperCardGrid>
          {status === "loading" ? genSkeletonCards() : genContentCards(data)}
          {isFetchingNextPage && genSkeletonCards()}
        </WrapperCardGrid>
      </Wrapper>
  );
};

export default CardsStyle;
